import React from 'react';
import { Profile, UnsavedProfile } from '../ProfileForm';
import ListItem from './ListItem';
import ProfileModal from './ProfileModal';
import NameForm from './NameForm';

interface NameProps {
  isAdmin: boolean;
  profile: Profile | UnsavedProfile;
  onSave: (name: string) => Promise<boolean>;
}

const Name: React.FC<NameProps> = ({ isAdmin, profile, onSave }) => {
  return (
    <>
      <ListItem id="displayName" title="Name" value={profile.displayName} />

      <ProfileModal title="Name" trigger="displayName">
        {({ close }) => (
          <NameForm
            name={profile.displayName}
            isAdmin={isAdmin}
            onSubmit={async (values) => {
              const success = await onSave(values.name);
              if (success) {
                close();
              }
            }}
          />
        )}
      </ProfileModal>
    </>
  );
};

export default Name;
